"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ARI = function ARI(props) {
  var size = props.size;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: size,
    height: size,
    preserveAspectRatio: "xMidYMid slice",
    clipRule: "evenodd",
    fillRule: "evenodd",
    viewBox: "0 0 560 400",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m363.323 84.277-72.028.052-146.293 231.464h115.434l-16.544-34.785 35.652-59.851c.93 3.69 2.796 11.001 3.077 12.118-1.824 3.163-29.396 50.866-29.396 50.866l42.545-35.163c.677.829 30.134 36.546 30.134 36.546s-13.852-46.247-14.783-49.393c.705-1.129 5.327-8.515 8.261-13.209l12.605 58.222-25.193 34.654h108.291l-51.766-231.509.006-.012zm-59.786 96.614h6.724l8.266 38.145h-37.719l22.731-38.145h-.001z",
    fill: "#e3d4ad"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m298.978 88.669 3.092 4.73h53.637l47.507 213.258h-77.178l17.239-23.316-24.749-110.71-20.462-.004-66.029 108.604 12.324 25.339h-76.466l-7.508 4.653h92.22l-14.595-30.089 62.621-104.427h13.638l23.644 105.477-21.243 29.07 92.524-.022-49.479-222.524-60.722-.04-.016.003zm-4.96.536-140.686 221.93 68.957-43.407 7.991-5.064-14.22-33.818 45.298-28.392-15.57-27.911 43.812-21.149-14.131-24.899 33.726-14.991-12.325-18.111-2.851-4.197v.007z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m302.067 93.401 13.218 20.294-33.325 14.993 14.354 24.853-43.79 20.95 14.652 27.162-45.309 28.552 13.956 34.246-67.934 42.121h76.464l-12.321-25.34 66.029-108.604 20.462.006 24.752 110.71-17.242 23.316h77.18l-47.508-213.258h-53.638zm-17.014 130.334s2.131 8.378 2.614 10.246c-1.295 2.235-17.269 29.865-17.269 29.865s22.771-18.824 25.999-21.486c2.232 2.701 18.319 22.208 18.319 22.208s-7.958-26.595-8.718-29.128c1.179-1.889 7.324-11.705 7.324-11.705h-28.268z",
    fill: "#a71930"
  }));
};

ARI.propTypes = {
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
ARI.defaultProps = {
  size: '100'
};
var _default = ARI;
exports["default"] = _default;